import script from "./UsuarioPasswordEstablecer.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPasswordEstablecer.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPasswordEstablecer.vue?vue&type=style&index=0&id=d8723058&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8723058"]])

export default __exports__